import { useContext, useState } from 'react'
import { useFormikContext } from 'formik'
import { emitCustomEvent } from 'react-custom-events'
import { motion } from "framer-motion"
import classnames from 'classnames/bind'
import { StoreContext } from '~/store'
import { FormContent, FormHeader, PackageDetails, PackageBookingSummary, ButtonDrawer, FormError } from '~/components'
import { StepperContext } from '~/components/ui/ViewStepper'
import { wrapWithValidation } from '~/utils'
import { createBooking } from '~/lib/api'
import { showErrorModal } from '~/utils'
import * as MotionElement from '~/components/ui/MotionElement'
import * as common from '~/config/common.module.css'
import * as styles from './index.module.css'
import { useTranslation } from 'react-i18next'

const cx = classnames.bind(common)

const ConfirmBooking = ({fullscreen, currentView}) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const { prev, next } = useContext(StepperContext)
  const { user, getActiveBookings } = useContext(StoreContext)

  const { values, errors, setFieldValue, setFieldError } = useFormikContext()

  const makeRequest = () => {
    setIsLoading(true)
    createBooking(values, user.userId).then((response) => {
      console.log(response)
      if (!isNaN(response?.bookingId)) {
        getActiveBookings()
        setFieldValue('bookingId', response.bookingId, false)
        next()
      }
    })
    .catch((error) => {
      if (error?.response?.error === 'INVALID_PHONE_NUMBER') {
        setFieldError('phone', error?.response?.message)
      }
      else if (!(error?.isUnauthorized || (error?.status === 401) || (error?.response?.status === 401 && error?.response?.error === 'Unauthorized'))) {
        console.error(error)
        showErrorModal(error?.response?.message || error?.message || 'Ett fel uppstod')
      }
    })
    .finally(() => {
      setIsLoading(false)
    })
  }

  const wrappedNext = wrapWithValidation(makeRequest, useFormikContext())

  // Deliveries are fixed price only. If the estimate failed we have no priceToken, and the
  // backend would reject the booking (FIXED_PRICE_REQUIRED), so block "Book now" and offer a retry.
  const fixedPrice = values.autoValues?.fixedPrice ?? values.fixedPrice
  const priceMissing = !!fixedPrice && !values.priceToken
  const retryEstimate = () => emitCustomEvent('RETRY_PRICE_ESTIMATE')

  const buttons = [
    { func: prev, isBack: true },
    { func: wrappedNext, title: t('button-book-now'), isLoading: isLoading || values.priceIsLoading, disabled: priceMissing },
  ]

  return (
    <div className={cx(common.widgetWrapper, styles.hideOverflow, { fullHeight:fullscreen, narrow:true, isLoading })}>
      <FormContent noRadius>
        <FormHeader>{t('header-confirm-your-booking')}</FormHeader>
        <PackageBookingSummary values={values} currentView={currentView} showPayment/>
        {priceMissing && !values.priceIsLoading && (
          <FormError>
            {errors.fixedPrice || t('info-price-estimate-failed')}{' '}
            <button type="button" onClick={retryEstimate} className="underline font-medium">{t('button-try-again')}</button>
          </FormError>
        )}
      </FormContent>
      <ButtonDrawer buttons={buttons} fullscreen={fullscreen}/>
    </div>
  )
}

ConfirmBooking.validationSchema = null

export default ConfirmBooking
